import { ChartDataPoint, DashboardPeriod, PERIOD_LABELS } from '@/lib/api/dashboard/dashboard-api'
import {
    Bar,
    BarChart,
    CartesianGrid,
    ResponsiveContainer,
    Tooltip,
    XAxis,
    YAxis,
} from 'recharts'

interface RevenueChartProps {
    data: ChartDataPoint[]
    period: DashboardPeriod
}

export default function RevenueChart({ data, period }: RevenueChartProps) {
    const total = data.reduce((sum, d) => sum + d.value, 0)
    const formattedTotal = new Intl.NumberFormat('pt-BR', {
        style: 'currency',
        currency: 'BRL',
    }).format(total / 100)

    const chartData = data.map(d => ({
        ...d,
        value: d.value / 100,
    }))

    return (
        <div className="bg-base-100 rounded-xl border border-base-300/50 p-5">
            <div className="flex items-center justify-between mb-4">
                <div>
                    <h3 className="text-lg font-semibold text-base-content">
                        Receita
                    </h3>
                    <p className="text-sm text-base-content/60">
                        {PERIOD_LABELS[period]}
                    </p>
                </div>
                <div className="text-right">
                    <p className="text-2xl font-bold text-success">{formattedTotal}</p>
                    <p className="text-xs text-base-content/60">Total</p>
                </div>
            </div>

            {data.length === 0 ? (
                <div className="flex items-center justify-center h-64 text-base-content/50">
                    Sem dados no período
                </div>
            ) : (
                <div className="w-full" style={{ height: '250px', minHeight: '250px' }}>
                    <ResponsiveContainer width="100%" height={250}>
                        <BarChart data={chartData} margin={{ top: 5, right: 10, left: 0, bottom: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" className="opacity-30" />
                            <XAxis
                                dataKey="label"
                                tick={{ fontSize: 12 }}
                                tickLine={false}
                                axisLine={false}
                            />
                            <YAxis
                                tick={{ fontSize: 12 }}
                                tickLine={false}
                                axisLine={false}
                                tickFormatter={(value) => `R$${value}`}
                            />
                            <Tooltip
                                contentStyle={{
                                    backgroundColor: 'oklch(var(--b1))',
                                    border: '1px solid oklch(var(--b3))',
                                    borderRadius: '8px',
                                }}
                                formatter={(value) => [
                                    new Intl.NumberFormat('pt-BR', {
                                        style: 'currency',
                                        currency: 'BRL',
                                    }).format(Number(value) || 0),
                                    'Receita',
                                ]}
                            />
                            <Bar
                                dataKey="value"
                                fill="#22c55e"
                                radius={[4, 4, 0, 0]}
                            />
                        </BarChart>
                    </ResponsiveContainer>
                </div>
            )}
        </div>
    )
}
